import { IFormulaExternalDataElement } from '@shared/interfaces';

export const externalData: IFormulaExternalDataElement[] = [];
